import angular from 'angular';
import animalInformationComponent from './animal-information.component';

export default angular.module('components.app.adverseEvent.animal-information', [])
  .component('animalInformation', animalInformationComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/animal-information/animal-information.module.js